const Image = require('../entities/image');

const PagedList = require('../entities/paged-list');

const s3FileUpload = require('../utils/s3-file-upload');

const {
  poll
} = require('../utils/poll');

const fields = ['id', 'url', 'mimeType', 'width', 'height'];

const parse = json => new Image(json);

class ImageRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: imageId*/
  ) {
    this.id = id;
    this.client = client;
  }

  details()
  /*: Promise<Image>*/
  {
    const req = new this.client.Request(`/imageRefs/${this.id}`, {}, fields);
    req.parse = parse;
    return this.client.get(req);
  }
  /* Response is
   * {
   *   id,
   *   status, // 'PENDING', 'FAILED', 'SUCCESS'
   *   created,
   *   updated,
   *   error
   * }
   *
   */


  checkUploadStatus()
  /*: Promise<any>*/
  {
    const req = new this.client.Request(`/media/upload/status`, {
      id: this.id
    }, ['status', 'error']);
    return this.client.get(req);
  }

}

class ImagesRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;

    this.for = (id
    /*: imageId*/
    ) => new ImageRepo(client, id);

    this.icanhas = this.for;
  }

  create(file
  /*: File*/
  , imageType
  /*: string*/
  , mimeType
  /*: string*/
  , width
  /*: number*/
  , height
  /*: number*/
  , size
  /*: number*/
  )
  /*: Promise<Image>*/
  {
    return this.client.uploads.create(imageType, mimeType, width, height, size).then(token => s3FileUpload(token, file, size, mimeType).then(() => this.client.uploads.publish(token))).then(result => {
      const predicate = () => this.for(result.id).checkUploadStatus().then(({
        status,
        error
      }) => {
        if (status === 'SUCCESS') return true;
        if (status === 'FAILED') throw error;
        return false;
      });

      return poll(predicate).then(() => result);
    }).then(({
      id
    }) => this.for(id).details());
  }

  listTypes() {
    const req = new this.client.Request(`/media/types`, {}, []);
    return this.client.get(req);
  }

  getType(sid
  /*: string*/
  )
  /*: Promise<PagedList<Object>>*/
  {
    const req = new this.client.Request(`/media/types/${sid}`, {}, []);
    return this.client.get(req);
  }

  resolve(provider, payload, signature, path) {
    const req = new this.client.Request('/images/resolve', {
      provider,
      payload,
      signature,
      path
    }, []);
    return this.client.post(req);
  }

}

module.exports = ImagesRepo;